export function routeMarketingEvent(event) {
  if (!event || !event.event) return;

  // SEND EMAIL
  if (
    event.event === 'onboarding_question'
    && event.quiz_question === 'send_email'
  ) {
    // Facebook
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'CompleteRegistration');
    }

    // TikTok
    if (typeof window.ttq === 'object') {
      window.ttq.identify({ email: event.quiz_answer });
      window.ttq.track('CompleteRegistration');
    }

    // Google Ads Conversion: send_email
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16857709798/PC5ZClr-i6UaEOb5sOY-',
      });
    }

    return;
  }

  // START QUIZ
  if (
    event.event === 'quiz_funnel'
    && event.quiz_action === 'start_quiz'
  ) {
    // Facebook
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'ViewContent');
    }

    // TikTok
    if (typeof window.ttq === 'object') {
      window.ttq.track('StartQuiz');
    }

    // Google Ads Conversion: start_quiz
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16857709798/NRmLCIzW6aUaEOb5sOY-',
      });
    }
  }
}
